export const PROPERTY_STATUS_ENUM = {
  Inactive: 'Inactive',
  Active: 'Active',
  Deactivated: 'Deactivated',
  Deleted: 'Deleted'
};

// Statuses users can filter the property navigation by (Deleted is never returned by the API)
export const PROPERTY_STATUS_FILTER_OPTIONS = [PROPERTY_STATUS_ENUM.Active, PROPERTY_STATUS_ENUM.Inactive, PROPERTY_STATUS_ENUM.Deactivated];
export const PROPERTY_STATUS_LABEL_KEYS = {
  [PROPERTY_STATUS_ENUM.Active]: 'general.active',
  [PROPERTY_STATUS_ENUM.Inactive]: 'general.inactive',
  [PROPERTY_STATUS_ENUM.Deactivated]: 'general.deactivated'
};

// export const PROPERTY_STEPS = {
//   PropertyInformation: 1,
//   ContactInformation: 2,
//   FeeSetup: 3,
//   PayoutDetails: 4,
//   UtilityConfiguration: 5,
//   UnitSetup: 6,
//   ConfirmProperty: 7,
// };

export const PROPERTY_STEPS = {
  PropertyInformation: 1,
  FeeSetup: 2,
  PayoutDetails: 3,
  UtilityConfiguration: 4,
  UnitSetup: 5,
  ConfirmProperty: 6
  // ContactInformation: 7,
};
export const DEMO_PROPERTY_STEPS = {
  PropertyInformation: 1,
  FeeSetup: 2,
  UtilityConfiguration: 3,
  UnitSetup: 4,
  ConfirmProperty: 5
};
export const APPFOLIO_PROPERTY_STEPS = {
  PropertyInformation: 0,
  UtilityConfiguration: 1,
  UnitSetup: 2,
  FeeSetup: 3,
  PayoutDetails: 4,
  ConfirmProperty: 5
};
export const BUILDING_CONTACT_TYPES = {
  building: 'Building',
  utility: 'Utility'
};